define.alias("shared/components/shared/wizards/credentials/connect-fb", "media/components/shared/wizards/credentials/connect-fb");